import React, { AnchorHTMLAttributes, PropsWithChildren, ReactNode } from 'react';
import styles from './account-panel.module.scss';
import { PrimaryButton, PrimaryButtonProps, OverflowTooltip } from '@workday/canvas-kit-react';
import { ExternalLink } from '../externalLink/ExternalLink';
import { AvatarProps, Avatar } from '../avatar/avatar';
import accountInfoAvatar from '../../assets/account_info_avatar.svg';

function AccountPanelAvatar(props: Omit<AvatarProps, 'avatarImg'>) {
    return <Avatar className={styles.avatar} avatarImg={accountInfoAvatar} {...props} />;
}

interface AccountPanelProps {
    children: ReactNode;
}
function AccountPanel({ children }: AccountPanelProps) {
    return <div className={styles.accountInfoPanel}>{children}</div>;
}

function AccountPanelSignOutButton(props: PrimaryButtonProps | React.ButtonHTMLAttributes<HTMLButtonElement>) {
    return <PrimaryButton className={styles.signOutButton} grow={true} {...props} />;
}

interface AccountPanelFooterProps {
    children: ReactNode;
}

function AccountPanelFooter({ children }: AccountPanelFooterProps) {
    return (
        <OverflowTooltip>
            <div className={styles.footer}>{children}</div>
        </OverflowTooltip>
    );
}

function AccountPanelUsername({ children }: { children: ReactNode }) {
    return (
        <OverflowTooltip>
            <div className={styles.name}>{children}</div>
        </OverflowTooltip>
    );
}

function AccountPanelEmail({ children }: { children: ReactNode }) {
    return (
        <OverflowTooltip>
            <div className={styles.email}>{children}</div>
        </OverflowTooltip>
    );
}

function AccountPanelFooterLink(props: PropsWithChildren<AnchorHTMLAttributes<HTMLAnchorElement>>) {
    return <ExternalLink className={styles.footerLink} {...props} />;
}

AccountPanel.Footer = AccountPanelFooter;
AccountPanel.SignOutButton = AccountPanelSignOutButton;
AccountPanel.Avatar = AccountPanelAvatar;
AccountPanel.Username = AccountPanelUsername;
AccountPanel.Email = AccountPanelEmail;
AccountPanel.FooterLink = AccountPanelFooterLink;

export { AccountPanel };
